import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ai-reco-card',
  templateUrl: './ai-reco-card.component.html',
  styleUrls: ['./ai-reco-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiRecoCardComponent {
  @Input() title: string = 'Recommendation';
  @Input() text: string = '';
  // Floating puts it fixed middle-right of the viewport
  @Input() floating: boolean = true;
  // CTA text shown on the card; clicking invokes open+call handlers
  @Input() ctaText: string = 'Click for insights & compliance checks';

  @Output() open = new EventEmitter<void>();
  @Output() call = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  onOpenClick() {
    this.open.emit();
  }

  onCallClick(ev: Event) {
    ev.stopPropagation();
    this.call.emit();
  }

  onCardClick(ev: Event) {
    // Clicking anywhere on the card should open the assistant and request AI recommendations.
    // Stop propagation to avoid unwanted parent handlers.
    ev.stopPropagation();
    this.open.emit();
    this.call.emit();
  }

  onDismiss(ev: Event) {
    ev.stopPropagation();
    this.dismiss.emit();
  }
}
